import React from 'react'
import { FormattedMessage } from 'react-intl'
import * as routes from 'core/routing/constants'
import BrandsList from './brands-list'
import ModelsGroupsList from './models-groups-list'
import Design from './design'
import Finalization from './finalization'
import Funding from './funding'
import Finishes from './finishes'
import Models from './models'
import Motors from './motors'
import Options from './options'
import ContractsList from './contracts-list'
import Congratulations from './congratulations'
import TradeIn from './trade-in'

const aSteps = [
  {
    hash: routes.CONFIGURATOR_BRANDS,
    title: <FormattedMessage id="configurator-wizard-title-1" />,
    subTitle: <FormattedMessage id="configurator-wizard-subtitle-1" />,
    component: <BrandsList />,
    nextButtonText: <FormattedMessage id="configurator-wizard-brands-nextButton" />
  },
  {
    hash: routes.CONFIGURATOR_MODELS_GROUPS,
    component: <ModelsGroupsList />,
    backButtonText: <FormattedMessage id="configurator-wizard-models-groups-backButton" />,
    nextButtonText: <FormattedMessage id="configurator-wizard-models-groups-nextButton" />
  },
  {
    hash: routes.CONFIGURATOR_MODELS,
    component: <Models />,
    backButtonText: <FormattedMessage id="configurator-wizard-models-backButton" />,
    nextButtonText: <FormattedMessage id="configurator-wizard-models-nextButton" />
  },
  {
    hash: routes.CONFIGURATOR_FINISHES,
    title: <FormattedMessage id="configurator-wizard-title-2" />,
    component: <Finishes />,
    backButtonText: <FormattedMessage id="configurator-wizard-finishes-backButton" />,
    nextButtonText: <FormattedMessage id="configurator-wizard-finishes-nextButton" />
  },
  {
    hash: routes.CONFIGURATOR_MOTORS,
    title: <FormattedMessage id="configurator-wizard-title-3" />,
    subTitle: <FormattedMessage id="configurator-wizard-subtitle-3" />,
    component: <Motors />,
    backButtonText: <FormattedMessage id="configurator-wizard-motors-backButton" />,
    nextButtonText: <FormattedMessage id="configurator-wizard-motors-nextButton" />
  },
  {
    hash: routes.CONFIGURATOR_DESIGN,
    title: <FormattedMessage id="configurator-wizard-title-4" />,
    component: <Design />,
    backButtonText: <FormattedMessage id="configurator-wizard-design-backButton" />,
    nextButtonText: <FormattedMessage id="configurator-wizard-design-nextButton" />
  },
  {
    hash: routes.CONFIGURATOR_OPTIONS,
    title: <FormattedMessage id="configurator-wizard-title-5" />,
    component: <Options />,
    backButtonText: <FormattedMessage id="configurator-wizard-options-backButton" />,
    nextButtonText: <FormattedMessage id="configurator-wizard-options-nextButton" />
  },
  {
    hash: routes.CONFIGURATOR_CONTRACTS,
    title: <FormattedMessage id="configurator-wizard-title-5" />,
    component: <ContractsList />,
    backButtonText: <FormattedMessage id="configurator-wizard-contracts-backButton" />,
    nextButtonText: <FormattedMessage id="configurator-wizard-contracts-nextButton" />
  },
  {
    hash: routes.CONFIGURATOR_CONGRATULATIONS,
    component: <Congratulations />,
    backButtonText: <FormattedMessage id="configurator-wizard-congratulations-backButton" />
  },
  {
    hash: routes.CONFIGURATOR_TRADEIN,
    title: <FormattedMessage id="configurator-wizard-title-6" />,
    component: <TradeIn />
  },
  {
    hash: routes.CONFIGURATOR_FUNDING,
    title: <FormattedMessage id="configurator-wizard-title-7" />,
    component: <Funding />,
    backButtonText: <FormattedMessage id="configurator-wizard-funding-backButton" />,
    nextButtonText: <FormattedMessage id="configurator-wizard-funding-nextButton" />
  },
  {
    hash: routes.CONFIGURATOR_FINALIZATION,
    title: <FormattedMessage id="configurator-wizard-title-8" />,
    component: <Finalization />,
    backButtonText: <FormattedMessage id="configurator-wizard-finalization-backButton" />
  }
]

export default aSteps
